import React, { useState, useEffect, useMemo } from "react";
import style from "./styles.module.scss";

import ProcessTable from "./tables/ProcessTable";
import UnitOperationTable from "./tables/UnitOpretionTable";
import StepOpretionTable from "./tables/StepOperationTable";
import UnitTable from "./tables/UnitTable";
import CriticalityTable from "./tables/CriticalityTable";

import ParaType from "./tables/ParaType";
import ParaInTable from "./tables/ParaInTable";
import ParaOutTable from "./tables/ParaOutTable";
import ParaSampleTable from "./tables/ParaSampleTable";
import ParaUnitTable from "./tables/ParaUnitTable";
import OtherTable from "./tables/Other Table";
import ParaQCOptionTable from "./tables/ParaQCOptionTable";
import {useTranslation} from "react-i18next";

const App = () => {
    const { t } = useTranslation(["page"]);

    return (
        <div className="bpl-container">
            <section className={`${style.section}`}>
                <div className={`${style.top}`}>
                    <h3 className={`${style.title}`}>{t("masterTable")}</h3>
                </div>
                <div className={`${style.mainbox}`}>
                    <div className={`${style.mainTop}`}>
                        <ProcessTable />
                        <div className={`${style.mainTopRight}`}>
                            <div className={`${style.mainTopTable}`}>
                                <UnitOperationTable />
                                
                                {/* Unit Operation 선택 안한 경우 숨기기 */}
                                <StepOpretionTable />
                            </div>
                            <UnitTable />
                            <CriticalityTable />
                            <OtherTable />
                        </div>
                    </div>
                    <div className={`${style.mainBottom}`}>
                        <ParaType />
                        <article>
                            <ParaInTable />
                            <ParaOutTable />
                            <ParaSampleTable />
                            <ParaQCOptionTable />
                            <ParaUnitTable />
                        </article>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default App;
